module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: _vm.classes
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4977ca2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/list-item.vue
// module id = 713
// module chunks = 85